(function() {
    'use strict';

    angular
        .module('solution', [
            'ngAnimate',
            'ngCookies',
            'ngTouch',
            'ngSanitize',
            'ngMessages',
            'ngAria',
            'ngResource',
            'ui.router',
            'ui.bootstrap',
            'toastr',
            'underscore',
            'mgcrea.ngStrap',
            'rzModule',
            'oitozero.ngSweetAlert'
        ]);

})();

(function() {
    'use strict';

    angular
        .module('solution')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider

            .state('app.negotiation', {
                url: '/negotiation',
                template: '<ui-view />',
                abstract: true
            })
            .state('app.negotiation.view', {
                url: '/{identity}/view',
                templateUrl: 'app/modules/negotiation/negotiation-view.html',
                controller: 'NegotiationViewController',
                controllerAs: 'vm',
                resolve: {
                    AuthUser: function(User) {
                        return User.getCurrent();
                    },
                    viewNegotiation: function($stateParams, Negotiation) {
                        return Negotiation.get($stateParams.identity);
                    }
                }
            })
            .state('app.negotiation.create', {
                url: '/create',
                templateUrl: 'app/modules/negotiation/negotiation-create.html',
                controller: 'NegotiationCreateController',
                controllerAs: 'vm',
                resolve: {
                    AuthUser: function(User) {
                        return User.getCurrent();
                    }
                }
            });

        $urlRouterProvider.otherwise('/');
    }

})();

(function() {
    'use strict';

    angular
        .module('solution')
        .factory('Negotiation', Negotiation);

    /** @ngInject */
    function Negotiation($log, $q, $state, API) {
        
        var factory = {
            getAll: getAll,
            get: get,
            save: save,
            update: update,
            impasse: impasse
        };

        function getAll() {
            var deferred = $q.defer();
            API.get('negotiation').then(function(response) {
                $log.debug('[Negotiation] getAll()', response);
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Negotiation] getAll()', response);
                if (response.status == 401) {
                    $state.go('login');
                    deferred.resolve();
                }
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.get('negotiation?identity=' + identity).then(function(response) {
                $log.debug('[Negotiation] get()', response);
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Negotiation] get()', response);
                if(angular.isDefined(response.status) && response.status !== -1) {
                    $state.go(response.status.toString(), {}, {reload:true});
                }
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.post('negotiation', payload).then(function(response) {
                $log.debug('[Negotiation] save()', response);
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Negotiation] save()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.put('negotiation', payload).then(function(response) {
                $log.debug('[Negotiation] update()', response);
                deferred.resolve(response);
            }, function(response) {
                $log.error('[Negotiation] update()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function impasse(identity) {
            var deferred = $q.defer();
            API.put('negotiation?identity=' + identity, { impasse: true }).then(function(response) {
                $log.debug('[Negotiation] impasse()', response);
                deferred.resolve(response);
            }, function(response) {
                $log.error('[Negotiation] impasse()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        return factory;
        
    }
})();

(function() {
    'use strict';

    angular
        .module('solution')
        .controller('NegotiationViewController', NegotiationViewController);

    /** @ngInject */
    function NegotiationViewController($scope, $state, $stateParams, $log, Negotiation, GoalService, ResolutionService, _, $window, AuthUser, Goal, viewNegotiation, SweetAlert) {

        if(angular.isUndefined(viewNegotiation)) {
            $state.go('app.profile', {}, {reload:true});
            return;
        }
       
        var vm = this;
        
        $scope.Goal = Goal;

        vm.form = {
            negotiation: {},
            resolution: ''
        };
        
        vm.confirmImpasse = confirmImpasse;
        
        constructor();

        vm.updateTimeline = function() {
            Negotiation.get($stateParams.identity).then(function(negotiation) {
                vm.negotiation = negotiation;

                if (vm.negotiation.instigator.email == AuthUser.user.email) {
                    vm.instigator = vm.negotiation.instigator;
                    vm.participant = vm.negotiation.responder;
                } else {
                    vm.instigator = vm.negotiation.responder;
                    vm.participant = vm.negotiation.instigator;
                }
            });
        }

        vm.goalService = new GoalService(vm);
        vm.resService = new ResolutionService(vm);

        function constructor() {
            vm.negotiation = viewNegotiation;

            if (vm.negotiation.instigator.email == AuthUser.user.email) {
                vm.instigator = vm.negotiation.instigator;
                vm.participant = vm.negotiation.responder;
            } else {
                vm.instigator = vm.negotiation.responder;
                vm.participant = vm.negotiation.instigator;
            }

            vm.form.negotiation = {
                negotiation_id: vm.negotiation.id,
                goals: []
            };
        }
           

        /**
         * Determines what step of the negotiation the user is on
         * @return {[type]} [description]
         */
        vm.getStep = function() {
            if (vm.negotiation && vm.negotiation.status) {
                switch (vm.negotiation.status.toLowerCase()) {
                    case 'active':
                        var instigator = vm.negotiation.instigator;
                        var participant = vm.negotiation.participant;
                        if (instigator.goals.length < 1) {
                            return 1; // You need to enter goals
                        }
                        if (instigator.goals.length > 0 && participant.goals.length < 1) {
                            return 2; // Waiting on participant to enter goals
                        }
                        // Resolutions Stage
                        if (instigator.goals.length > 0 && participant.goals.length > 0) {
                            if (instigator.resolutions.length < 1 && participant.resolutions.length < 1)
                                return 3; // Either party can submit a resolution first
                            if (instigator.resolutions.length > 0 || participant.resolutions.length > 0) {
                                var instigatorOpen = _.filter(instigator.resolutions, function(resolution) {
                                    return !resolution.accepted && resolution.accepted != false;
                                });
                                var participantOpen = _.filter(participant.resolutions, function(resolution) {
                                    return !resolution.accepted && resolution.accepted != false;
                                });

                                if (instigatorOpen.length > participantOpen.length)
                                    return 4; // Waiting on the other party to accept/reject your resolution
                                if (instigatorOpen.length < participantOpen.length)
                                    return 5; // Waiting on you to accept/reject the proposed resolutions
                            }
                        }
                        break;
                    case 'impasse':
                        return 7; //impassed
                    case 'resolved':
                        return 6;
                }
            }
            return -1;
        }

        vm.pluralize = function(word) {
            if (word.slice(-1).toLowerCase() == 's')
                return word + "'";
            else
                return word + "'s";
        }

        vm.getCurrentStep = function() {
            switch (vm.negotiation.status) {
                case 'Active':

                    break;
                case 'Impasse':
                    return 7; //TODO fix this
            }
            console.log('negotiation', vm.negotiation);

        }

        vm.styles = {
            participant: {
                goals: '430px',
                resolutions: '430px'
            },
            instigator: {
                goals: '430px',
                resolutions: '430px'
            }
        };

        vm.prioritySlider = {
            value: 0,
            options: {
                floor: 0,
                ceil: 3,
                showTicks: true,
                translate: function(value) {
                    return Goal.getPriorityLabel(value);
                }
            }
        };

        vm.print = function() {
            $window.print();
        }
        
        function confirmImpasse() {
            SweetAlert.swal({
                title: 'Are you sure?',
                text: 'This means a resolution could not be reached. This action cannot be undone.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#B9151B',
                confirmButtonText: 'Impasse',
                cancelButtonText: 'Cancel',
                closeOnConfirm: true
            },
            function(isConfirm) {
                if(isConfirm) {
                    Negotiation.impasse($stateParams.identity).then(function() {
                        vm.updateTimeline();
                    }, function(response) {
                        $log.error('There was an issue impassing the negotiation.', response);
                    });
                }
            });
            
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('solution')
        .controller('NegotiationCreateController', NegotiationCreateController)

    /** @ngInject */
    function NegotiationCreateController($scope, $state, Negotiation, Email, AuthUser, Goal, SweetAlert, $log) {

        $scope.Goal = Goal;
        
        var vm = this;
        
        var saving = false;
        
        vm.currentStep = 1;

        vm.negotiation = {
            participant: {},
            description: '',
            category: ''
        };
        
        vm.prioritySlider = {
            value: 0,
            options: {
                floor: 0,
                ceil: 3,
                showTicks: true,
                translate: function(value) {
                    return Goal.getPriorityLabel(value);
                }
            }
        };
        
        vm.isValidEmail = isValidEmail;
        vm.nextStep = nextStep;
        vm.previousStep = previousStep;
        vm.canAdvance = canAdvance;

        /**
         * Navigates to the next step of the negotiation wizard
         */
        function nextStep() {
            if (vm.canAdvance() && vm.currentStep !== 5)
                vm.currentStep++;
            if (vm.currentStep === 5 && !saving) {
                saving = true;
                vm.negotiation.goals = Goal.values;
                Negotiation.save(vm.negotiation).then(function(response) {
                    SweetAlert.success('Negotiation Started', 'You have successfully started a new negotiation. Please wait for ' + vm.negotiation.participant.firstName + ' ' + vm.negotiation.participant.lastName + ' to respond.');
                    vm.negotiation = {};
                    Email.sendInvite(response).then(function(data) {
                        $state.go('app.negotiation.view', { identity: response.id });
                    }, function() {
                        $state.go('app.negotiation.view', { identity: response.id });
                    });
                }, function(response) {
                    $log.error('There was an issue saving the negotiation.', response);
                    saving = false;
                    SweetAlert.error('Error Saving', 'There was an issue saving the negotiation. Please contact support.');
                });

            }
        }
        
        /**
         * Navigates to the previous step of the negotiation wizard
         */
        function previousStep() {
            if(vm.currentStep !== 1)
                vm.currentStep--;
        }

        function canAdvance() {
            switch (vm.currentStep) {
                /*
                 * Step: Who is this negotiation with?
                 */
                case 1:
                    if (vm.negotiation.participant.firstName && vm.negotiation.participant.firstName.trim().length > 0) {
                        if (vm.negotiation.participant.lastName && vm.negotiation.participant.lastName.trim().length > 0) {
                            if (vm.negotiation.participant.email && vm.negotiation.participant.email.trim().length > 0) {
                                if (vm.negotiation.participant.email == AuthUser.user.email)
                                    return false;
                                return true;
                            }
                        }
                    }
                    return false;
                /*
                 * Step: What is the negotiation about?
                 */
                case 2:
                    return vm.negotiation.description && vm.negotiation.description.trim().length > 0;
                /*
                 * Step: Create goals for this negotiation.
                 */
                case 3:
                    return Goal.hasGoals();
                /*
                 * Step: Review your information.
                 */
                case 4:
                    return true;
            }
            return false;
        }

        /**
         * Determines if the participant's email address is not the currently
         * authenticated user's email address
         */
        function isValidEmail() {
            return vm.negotiation.participant.email !== AuthUser.user.email;
        }
  
        
    }
})();

(function() {
    'use strict';

    angular
        .module('solution')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('home', {
                url: '/',
                templateUrl: 'app/modules/marketing/index.html'
            })
            .state('about', {
                url: '/about-us',
                templateUrl: 'app/modules/marketing/about-us.html'
            })
            .state('works', {
                url: '/how-it-works',
                templateUrl: 'app/modules/marketing/how-it-works.html'
            })
            .state('contact', {
                url: '/contact-us',
                templateUrl: 'app/modules/marketing/contact-us.html',
                controller: 'MarketingController',
                controllerAs: 'vm'
            })
            .state('404', {
                url: '/404',
                templateUrl: 'app/modules/marketing/404.html'
            })
            .state('401', {
                url: '/401',
                templateUrl: 'app/modules/marketing/401.html'
            });

        $urlRouterProvider.otherwise('/');
    }

})();

(function() {
    'use strict';

    angular
        .module('solution')
        .controller('MarketingController', MarketingController);

    /** @ngInject */
    function MarketingController(Email, $log) {

        var vm = this;

        vm.form = {};

        vm.submitted = false;
        vm.sendMessage = sendMessage;

        function sendMessage() {
            vm.submitted = true;
            if(!vm.contactForm.$valid)
                return;
            Email.sendContactUs(vm.form).then(function(response) {
                if(response.status == 200)
                    vm.sentSuccess = true;
                else
                    vm.sentSuccess = false;
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('solution')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('app.profile', {
                url: '/profile',
                templateUrl: 'app/modules/dashboard/dashboard.html',
                controller: 'DashboardController',
                controllerAs: 'vm',
                resolve: {
                    getNegotiationsResolve: function(Negotiation) {
                        return Negotiation.getAll();
                    },
                    AuthUser: function(User) {
                        return User.getCurrent();
                    }
                }
            });

        $urlRouterProvider.otherwise('/');
    }

})();

(function() {
    'use strict';

    angular
        .module('solution')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(getNegotiationsResolve, AuthUser, NegotiationService) {

        var vm = this;

        vm.negotiations = getNegotiationsResolve;
        vm.user = AuthUser.user;

        vm.negService = new NegotiationService(vm);
    }
})();

(function() {
    'use strict';

    angular.module('solution')
        .factory('User', User);

    /** @ngInject */
    function User($log, $q, $state, API) {

        var factory = {};

        factory.getCurrent = function() {
            var deferred = $q.defer();
            API.get('authenticate/user').then(function(response) {
                $log.debug('[User] getCurrent()', response);
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[User] getCurrent()', response);
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        return factory;
    }
})();
(function() {
    'use strict';
    angular.module('solution')
        .directive('trimTo', trimTo);

    /** @ngInject */
    function trimTo($compile) {

        var directive = {
            restrict: 'A',
            transclude: true,
            template: '<span ng-transclude></span>',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var text = attrs.trimTo;
            var length = attrs.length;

            scope.expandText = expandText;

            var html = text.substring(0, length) + (text.length > length ? '...' : '');

            element.html(html);

            if (attrs.showMore && text.length > length) {
                var expandLink = angular.element('<a ng-click="expandText()">Learn more <i class="fa fa-angle-double-right"></i></a>');
                $compile(expandLink)(scope);
                element.append(expandLink);
            }

            function expandText() {
                element.html(text);
            }
        }

    }
})();

(function() {
    'use strict';

    angular.module('solution')
        .directive('svgLoader', svgLoader);

    /** @ngInject */
    function svgLoader($timeout, $interval, svgLoaderConstant) {

        var directive = {
            restrict: 'AE',
            scope: {
                'ngModel': '='
            },
            templateUrl: '/app/components/svgLoader/svgLoader.html',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var animationStart, animationEnd, promise;

            setDefaultValues();

            function setDefaultValues() {
                scope.isVisible = scope.ngModel;
                scope.icon = attrs.svgLoader ? attrs.svgLoader : svgLoaderConstant.default_icon;
                scope.placeholder = attrs.placeholder;
                scope.defaultClasses = svgLoaderConstant.loader_fixed ? 'fixed' : '';
            }

            scope.$watch(function() {
                return scope.ngModel;
            }, function(newVal) {
                if (newVal == true) {
                    animationStart = Date.now();
                    scope.isVisible = true;
                } else {
                    if (animationStart) {
                        var animationEnd = Date.now();
                        promise = $interval(function() {
                            if (animationEnd - animationStart > svgLoaderConstant.animation_time) {
                                $timeout(function() {
                                    scope.isVisible = false;
                                    animationStart = undefined;
                                    animationEnd = undefined;
                                });
                                $interval.cancel(promise);
                            } else
                                animationEnd = Date.now();
                        }, 750);
                    }
                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular.module('solution')
        .constant('svgLoaderConstant', svgLoaderConstant);

    var svgLoaderConstant = {
        default_icon    : 'grid',
        load_time_delay : 500,
        animation_time  : 500,
        loader_fixed    : false
    };

})();
(function() {
    'use strict';

    angular.module('solution')
        .service('ResolutionService', ResolutionService);

    /** @ngInject */
    function ResolutionService($log, API, _) {
        var scope, hasError = false,
            declineResolution = false;

        var ResolutionService = function(parentScope) {
            $log.debug('ResolutionService()', parentScope);
            scope = parentScope;
        }

        /**
         * Checks if the goal input form is valid for submission
         * @return {Boolean} Whether the form is valid or invalid
         */
        function isValidForm() {
            if (!scope.form)
                return false;
            if (!scope.form.negotiation.resolution || scope.form.negotiation.resolution.trim().length < 0) {
                $log.debug('[ResolutionService] isValidForm(): The user has not entered text for a resolution.');
                return false;
            }
            return true;
        }

        ResolutionService.prototype.hasError = function() {
            return hasError;
        }

        ResolutionService.prototype.checkOverflow = function(type) {
            switch (type.toLowerCase()) {
                case 'participant':
                    if (scope.styles.participant.resolutions == 'none')
                        return false;
                    return checkOverflow(angular.element(document).find($('.resolutions-group.participant'))[0]);
                case 'instigator':
                    if (scope.styles.instigator.resolutions == 'none')
                        return false;
                    return checkOverflow(angular.element(document).find($('.resolutions-group.instigator'))[0])
            }
        }

        ResolutionService.prototype.expandResolutions = function(type) {
            switch (type.toLowerCase()) {
                case 'participant':
                    scope.styles.participant.resolutions = 'none';
                    break;
                case 'instigator':
                    scope.styles.instigator.resolutions = 'none';
                    break;
            }
        }

        ResolutionService.prototype.current = function() {
            return _.find(scope.negotiation.participant.resolutions, function(resolution) {
                return !resolution.accepted && resolution.accepted != false;
            });
        }

        ResolutionService.prototype.accept = function() {
            API.put('resolution', ResolutionService.prototype.current()).then(function(response) {
                $log.debug('ResolutionService.accept()', response);
                scope.updateTimeline();
            }, function(response) {
                $log.error('ResolutionService.accept()', response);
            });
        }

        ResolutionService.prototype.decline = function() {
            declineResolution = true;
        }

        ResolutionService.prototype.cancelDecline = function() {
            declineResolution = false;
        }

        ResolutionService.prototype.isDeclining = function() {
            return declineResolution;
        }

        function checkOverflow(element) {
            return element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
        }

        ResolutionService.prototype.getLabelText = function(resolution) {
            if (resolution.accepted == true)
                return 'Accepted';
            if (resolution.accepted == false)
                return 'Deferred';
            return 'Waiting';
        }

        ResolutionService.prototype.getLabelColor = function(resolution) {
            if (resolution.accepted == true)
                return 'label-success';
            if (resolution.accepted == false)
                return 'label-warning';
            return 'label-primary';
        }

        ResolutionService.prototype.submit = function() {
            $log.debug('ResolutionService.submit', scope.form.negotiation);
            if (!isValidForm()) {
                hasError = true;
                return;
            }
            API.post('resolution', scope.form.negotiation).then(function(response) {
                $log.debug('ResolutionService.submit()', response);
                scope.updateTimeline();
            }, function(response) {
                $log.error('ResolutionService.submit()', response);
            });
        }


        return ResolutionService;
    }
})();

(function() {
	'use strict';

	angular
		.module('solution')
		.directive('toggle', toggle);

	function toggle($document) {
	
		var directive = {
			link: linkFunc,
			restrict: 'A',
			scope: {
			}
		};
		return directive;

		function linkFunc(scope, element, attrs) {
            
            var targetClass = attrs.toggle;
            var target = $document.find('.'+targetClass);
			
			var onClick = function(event) {
                var isChild = element.has(event.target).length > 0;
                var isSelf = element[0] == event.target;
                var isInside = isChild || isSelf;
                if (!isInside)
                    scope.$apply(target.removeClass(angular.isUndefined(attrs.add) ? targetClass : attrs.add));
            }
			
			$document.bind('click', onClick);
            
			element.bind('click', function() { 
                
                if(angular.isUndefined(attrs.add))
                    target.toggleClass(targetClass);
                else
                    target.toggleClass(attrs.add);
			});
			
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('solution')
		.directive('goalContainer', goalContainer);

	/** @ngInject */
	function goalContainer(Goal, $timeout) {

		var directive = {
			restrict: 'A',
			templateUrl: '/app/components/goal/goalContainer.html',
			link: linkFunc,
			scope: {
				goals: '=goalContainer',
				edit: '&'
			}
		};

		return directive;

		function linkFunc(scope, element, attrs) {

			scope.showScrollMsg = false;
			scope.showScrollDown = true;
			scope.showScrollUp = false;
			scope.Goal = Goal;
			scope.scrollTop = scrollTop;

			var listGroup = element.find('.list-group');

			/**
			 * Listens for modifications to the container to
			 * determine if the scroll message should be displayed
			 */
			listGroup.bind('DOMSubtreeModified', function() {
				if (listGroup[0].offsetHeight < listGroup[0].scrollHeight) {
					$timeout(function() {
						scope.showScrollMsg = true;
					}, 0);
				}
				else {
					$timeout(function() {
						scope.showScrollMsg = false;
					}, 0);
				}
			});
			
			/**
			 * Binds the scroll event for the container to determine 
			 * which message should be displayed to the user (up vs. down)
			 */
			listGroup.bind('scroll', function() {
				if(listGroup[0].offsetHeight + listGroup.scrollTop() + 30 > listGroup[0].scrollHeight) {
					$timeout(function() {
						scope.showScrollUp = true;
						scope.showScrollDown = false;
					}, 0);
				}
				else {
					$timeout(function() {
						scope.showScrollDown = true;
						scope.showScrollUp = false;
					}, 0);
				}
				
			});
			
			/**
			 * Scrolls the user back to the top of the container
			 */
			function scrollTop() {
				listGroup[0].scrollTop = 0;
			}


		}
	}

})();
(function() {
    'use strict';

    angular
        .module('solution')
        .service('GoalService', GoalService);

    /** @ngInject */
    function GoalService($log, API) {

        var goalForm;

        var goalIndex = 0;

        var scope;

        var hasError = false;

        var GoalService = function(parentScope) {
            $log.debug('GoalService()', parentScope);
            scope = parentScope;
        }


        /**
         * Checks if the goal input form is valid for submission
         * @return {Boolean} Whether the form is valid or invalid
         */
        function isValidForm() {
            if(!scope.form || !scope.form.negotiation || !scope.form.negotiation.goals)
                return false;
            var goal = scope.form.negotiation.goals[goalIndex];
            if(!goal)
                return false;
            if(!goal.goal || goal.goal.trim().length < 0)
                return false;
            if(!goal.reason || goal.reason.trim().length < 0)
                return false;
            if(!goal.priority || goal.priority == NaN)
                goal.priority = 0;
            return true;
        }

        GoalService.prototype.isValid = function() {
            return isValidForm();
        }

        GoalService.prototype.hasGoalText = function() {
            if(!scope.form || !scope.form.negotiation || !scope.form.negotiation.goals)
                return false;
            var goal = scope.form.negotiation.goals[goalIndex];
            return goal && goal.goal && goal.goal.trim().length > 0;
        }

        GoalService.prototype.hasReasonText = function() {
            if(!scope.form || !scope.form.negotiation || !scope.form.negotiation.goals)
                return false;
            var goal = scope.form.negotiation.goals[goalIndex];
            return goal && goal.reason && goal.reason.trim().length > 0;
        }

        GoalService.prototype.hasError = function() {
            return hasError;
        }

        function setGoalIndex(index) {
            goalIndex = index;
        }

        GoalService.prototype.addAdditionalGoal = function() {
            $log.debug('Valid Form', isValidForm());
            if(isValidForm()) {
                hasError = false;
                setGoalIndex(++goalIndex);
                $log.debug('GoalIndex', goalIndex);
            }
            else {
                hasError = true;
            }
        }

        GoalService.prototype.getCount = function() {
            return scope.form.negotiation && scope.form.negotiation.goals ? scope.form.negotiation.goals.length + 1 : 2;
        }

        GoalService.prototype.getOrdinal = function() {
            var count = GoalService.prototype.getCount();
            var suffix = ['th','st','nd','rd'];
            var value = count%100;
            return (suffix[(value-20)%10]||suffix[value]||suffix[0]);
        }

        GoalService.prototype.submit = function() {
            $log.debug('GoalService.submit', scope.form.negotiation);
            if(!isValidForm()) {
                hasError = true;
                return;
            }
            API.post('goals', scope.form.negotiation).then(function(response) {
                $log.debug('GoalService.submit()', response);
                scope.updateTimeline();
            }, function(response) {
                $log.error('GoalService.submit()', response);
            });
        }

        /**
         * The current index of the goal being editted or created
         * @return {Integer} The index of the goals array object
         */
        GoalService.prototype.getIndex = function() {
            return goalIndex;
        }

        GoalService.prototype.submitBtn = function() {
            var count = goalIndex;
            count++;
            if(count > 0)
                return 'Submit ' + count + (count == 1 ? ' Goal' : ' Goals');
            return 'Submit Goals';
        }

        GoalService.prototype.expandGoals = function(type) {
            switch(type.toLowerCase()) {
                case 'participant':
                    scope.styles.participant.goals  = 'none';
                    break;
                case 'instigator':
                    scope.styles.instigator.goals = 'none';
                    break;
            }
        }

        GoalService.prototype.checkGoalOverflow = function(type) {
            switch(type.toLowerCase()) {
                case 'participant':
                    if(scope.styles.participant.goals == 'none')
                        return false;
                    return checkOverflow(angular.element(document).find($('.goals-group.participant'))[0]);
                case 'instigator':
                    if(scope.styles.instigator.goals == 'none')
                        return false;
                    return checkOverflow(angular.element(document).find($('.goals-group.instigator'))[0])
            }
        }

        function checkOverflow(element) {
            return element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
        }

        return GoalService;

    }
})();
(function() {
	'use strict';

	angular
		.module('solution')
		.factory('Goal', Goal);

	function Goal() {

		var index = 0;
		var goals = [{
			priority: 0
		}];
		var error = false;

		var factory = {
			getPriorityClass: getPriorityClass,
			getPriorityLabel: getPriorityLabel,
			isValid: isValid,
			getIndex: getIndex,
			getSuffix: getSuffix,
			values: goals,
			getAll: getAll,
			getCount: getCount,
			add: add,
			edit: edit,
			hasError: hasError,
			hasGoals: hasGoals
		};

		return factory;

		function getPriorityClass(priority) {
			switch (priority) {
				case 0:
					return 'label-primary';
				case 1:
					return 'label-success';
				case 2:
					return 'label-warning';
				case 3:
					return 'label-danger';
				default:
					priority = 0;
					return 'label-primary';
			}
		}

		function getPriorityLabel(priority) {
			switch (priority) {
				case 0:
				default:
					priority = 0;
					return 'Desired';
				case 1:
					return 'Important';
				case 2:
					return 'Very Important';
				case 3:
					return 'Vital';
			}
		}

		function isValid(goal) {
			if (angular.isDefined(goal)) {
				if (angular.isDefined(goal.goal) && goal.goal.trim().length > 0) {
					if (angular.isDefined(goal.reason) && goal.reason.trim().length > 0) {
						if (angular.isDefined(goal.priority) && (goal.priority > -1 || goal.priority < 4))
							return true;
					}
				}
			}
			return false;
		}

		/**
		 * Returns the current goal index
		 */
		function getIndex() {
			return index;
		}

		/**
		 * Returns the suffix label for the next goal to add
		 * Used for the button text label
		 */
		function getSuffix() {
			var count = index + 2;
			var suffix = ['th', 'st', 'nd', 'rd'];
			var value = count % 100;
			return (suffix[(value - 20) % 10] || suffix[value] || suffix[0]);
		}

		/**
		 * Returns the collection of goals
		 */
		function getAll() {
			return goals;
		}

		/**
		 * Returns the number of valid goals
		 */
		function getCount() {
			var count = 0;
			if (goals) {
				angular.forEach(goals, function(goal) {
					if (isValid(goal))
						count++;
				});
			}
			return count;
		}

		/**
		 * Attempts to add another goal into the collection
		 */
		function add() {
			if(!isValid(goals[index])) {
				error = true;
				return;
			}
			if(hasGoals()) {
				error = false;
				index = goals.length;
				goals[index] = {
					priority: 0
				};
			}
		}
		
		/**
		 * Sets the index to modify to the index of the goal in the collection
		 */
		function edit(goal) {
			index = goals.indexOf(goal);
		}
		
		/**
		 * Returns if the goal has an error
		 */
		function hasError() {
			return error;
		}
		
		/**
		 * Determines if the user has at least 1 valid goal
		 */
		function hasGoals() {
			var hasGoal = false;
			angular.forEach(goals, function(goal) {
				if(isValid(goal))
					hasGoal = true;
			});
			return hasGoal;
		}

	}
})();
(function() {
    'use strict';

    angular.module('solution')
        .directive('fullHeight', fullHeight);

    /** @ngInject */
    function fullHeight($window) {

        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var headerAndFooter = 65;
            scope.initializeWindowSize = function() {
                $(element).css('min-height', $window.innerHeight - headerAndFooter);
                if (attrs.height)
                    $(element).css('height', $window.innerHeight - headerAndFooter);
            };
            scope.initializeWindowSize();
            angular.element($window).bind('resize', function() {
                scope.initializeWindowSize();
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('solution')
        .factory('Email', Email);

    /** @ngInject */
    function Email($log, $q, $state, API) {
        var factory = {};

        factory.sendInvite = function(negotiation) {
            var payload = {
                view: 'emails.invite',
                subject: 'Negotiation Invite - Solution Table LLC',
                email: negotiation.participant.email,
                name: negotiation.instigator.name,
                identity: negotiation.id,
                negotiation: negotiation.description
            }
            $log.debug('Sending Payload', payload);

            $log.info(angular.toJson(payload));
            var deferred = $q.defer();
            API.post('email/send-email', payload).then(function(response) {
                $log.debug('[Email] sendInvite()', response);
                deferred.resolve(response);
            }, function(response) {
                $log.error('[Email] sendInvite()', response);
                deferred.resolve(response);
            });
            return deferred.promise;
        }

        factory.sendContactUs = function(form) {
            var payload = {
                view: 'emails.contact',
                subject: 'Solution Table - Contact Us Request',
                email: 'info@solutiontable.com',
                from: form.email,
                name: form.name,
                contactMsg: form.message
            }
            $log.debug('Sending Payload', payload);

            $log.info(angular.toJson(payload));
            var deferred = $q.defer();
            API.post('email/send-email', payload).then(function(response) {
                $log.debug('[Email] sendContactUs()', response);
                deferred.resolve(response);
            }, function(response) {
                $log.error('[Email] sendContactUs()', response);
                deferred.resolve(response);
            });
            return deferred.promise;
        }

        return factory;

    }
})();

(function() {
    'use strict';

    angular
        .module('solution')
        .factory('API', API);

    /** @ngInject */
    function API($log, $http, $location) {

        var domain;

        if($location.port() == 9000)
            domain = 'http://solutionTable/core/api/';
        else
            domain = 'http://solutiontable.com/core/api/';

        var factory = {
            get: get,
            post: post,
            put: put,
            login: login,
            logout:logout,
            register: register,
            getAuthUser: getAuthUser,
            submitNegotiation: submitNegotiation,
            getNegotiations: getNegotiations
        };

        return factory;

        function syncToken() {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        }

        function get(url) {
            syncToken();
            return $http.get(domain + url);
        }
        function post(url, payload) {
            syncToken();
            return $http.post(domain + url, payload);
        }
        function put(url, payload) {
            syncToken();
            return $http.put(domain + url, payload);
        }
        function login(account) {
            return $http.post(domain + 'authenticate/auth', account);
        }
        function logout() {
            return $http.get(domain + 'authenticate/logout');
        }
        function register(account) {
            return $http.post(domain + 'authenticate/register', account);
        }
        function getAuthUser() {
            syncToken();
            return $http.get(domain + 'authenticate/user');
        }
        function submitNegotiation(negotiation) {
            $http.post(domain + 'negotiation', negotiation).then(function(response) {
                $log.debug('Successfully saved negotiation');
            }, function(response) {
                $log.error('Error saving negotiation.', response);
            });
        }
        function getNegotiations() {
            return $http.get(domain + 'negotiation');
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('solution')
        .service('NegotiationService', NegotiationService);

    /** @ngInject */
    function NegotiationService($log, API, _) {

        var scope;

        var NegotiationService = function(parentScope) {
            $log.debug('NegotiationService()', parentScope);
            scope = parentScope;
        }

        NegotiationService.prototype.getStep = function(negotiation) {
            if (negotiation && negotiation.status) {
                switch (negotiation.status.toLowerCase()) {
                    case 'active':
                        var instigator = negotiation.instigator;
                        var participant = negotiation.participant;
                        if (instigator.goals.length < 1) {
                            return 1; // You need to enter goals
                        }
                        if (instigator.goals.length > 0 && participant.goals.length < 1) {
                            return 2; // Waiting on participant to enter goals
                        }
                        // Resolutions Stage
                        if (instigator.goals.length > 0 && participant.goals.length > 0) {
                            if (instigator.resolutions.length < 1 && participant.resolutions.length < 1)
                                return 3; // Either party can submit a resolution first
                            if (instigator.resolutions.length > 0 || participant.resolutions.length > 0) {
                                var instigatorOpen = _.filter(instigator.resolutions, function(resolution) {
                                    return !resolution.accepted && resolution.accepted != false;
                                });
                                var participantOpen = _.filter(participant.resolutions, function(resolution) {
                                    return !resolution.accepted && resolution.accepted != false;
                                });

                                if (instigatorOpen.length > participantOpen.length)
                                    return 4; // Waiting on the other party to accept/reject your resolution
                                if (instigatorOpen.length < participantOpen.length)
                                    return 5; // Waiting on you to accept/reject the proposed resolutions
                            }
                        }
                        break;
                    case 'impasse':
                        return 7; //impassed
                    case 'resolved':
                        return 6;
                }
            }
            return -1;
        }

        NegotiationService.prototype.isYourTurn = function(negotiation) {
            var step = NegotiationService.prototype.getStep(negotiation);
            return (step == 1 || step == 3 || step == 5);
        }

        NegotiationService.prototype.getStatusLabel = function(negotiation) {
            switch (negotiation.status.toLowerCase()) {
                case 'active':
                    return 'label-primary';
                case 'resolved':
                    return 'label-success';
                case 'draft':
                    return 'label-warning';
                case 'impasse':
                    return 'label-danger';
            }
        }

        NegotiationService.prototype.getActionText = function(negotiation) {
            if (NegotiationService.prototype.isYourTurn(negotiation))
                return 'Respond';
            return 'View';
        }

        return NegotiationService;

    }
})();

(function() {
    'use strict';

    angular
        .module('solution')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('professional', {
                url: '/find-a-professional',
                templateUrl: 'app/professional/professional.html',
                controller: 'ProfessionalController',
                controllerAs: 'vm'
            });

        $urlRouterProvider.otherwise('/');
    }

})();

(function() {
    'use strict';

    angular.module('solution')
        .factory('Professional', Professional);

    /** @ngInject */
    function Professional($log, $q, $state, API) {
        var factory = {};

        factory.getCategories = function() {
            var deferred = $q.defer();
            API.get('professional/categories').then(function(response) {
                $log.debug('[Professional] getCategories()', response);
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Professional] getCategories()', response);
                if (response.status == 401) {
                    $state.go('login');
                    deferred.resolve();
                }
            });
            return deferred.promise;
        }

        factory.find = function(form) {
            $log.debug(angular.toJson(form));
            var deferred = $q.defer();
            API.post('professional/find', form).then(function(response) {
                $log.debug('[Professional] find()', response);
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Professional] find()', response);
                deferred.resolve(response);
            })
            return deferred.promise;
        }

        return factory;
    }

})();

(function() {
    'use strict';

    angular.module('solution')
        .controller('ProfessionalController', ProfessionalController);

    function ProfessionalController($log, $scope, Email, Professional, $location, $anchorScroll, $window) {
        var vm = this;

        vm.form = {
            radius: '25',
            zip_code: '49007',
            category: '2'
        }

        vm.loaderVisible = false;

        vm.openWebsite = openWebsite;
        vm.searchProfessionals = searchProfessionals;

        Professional.getCategories().then(function(categories) {
            vm.categories = categories;
            $('.ui').dropdown();
        });

        function searchProfessionals() {

            var animationStart = Date.now();

            vm.loaderVisible = true;

            Professional.find($scope.form).then(function(professionals) {
                $location.hash(null)
                vm.loaderVisible = false;
                vm.professionals = professionals;
                $log.debug('Yay! Professionals!', professionals);
                $location.hash('professionals');
                $anchorScroll();
            }, function(response) {
                $log.error('Oh no!', response);
            });
        }

        function openWebsite(url) {
            $log.debug('Opening: ' + url);
            $window.open('//' + url);
        }

        $scope.$watch('vm.form.category', function(newVal, oldVal) {
            $log.debug('NewVal', newVal);
            $log.debug('OldVal', oldVal);
        });

    }
})();

(function() {
  'use strict';

  angular
    .module('solution')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, toastr, API, $rootScope, $state, SweetAlert) {
    var vm = this;
    
    vm.logout = logout;
    
    if (sessionStorage.getItem('token') && !$rootScope.user) {
        API.getAuthUser().then(function(response) {
            $rootScope.user = response.data.user;
        }, function(response) {
            if (response.status == 401) {
                sessionStorage.removeItem('token');
                $state.go('login');
            }
        });
    }
    
    function logout() {
        API.logout().then(function(response) {
            sessionStorage.removeItem('token');
            $rootScope.user = undefined;
            SweetAlert.success('Logged out.', 'You have successfully logged out.');
            $state.go('login', {}, {reload:true}); 
        });
        
    }
    

  }
})();

(function() {
    'use strict';

    angular
        .module('solution')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController($state, API, $stateParams) {
        var vm = this;

        vm.errors = [];
        vm.form = {};

        vm.register = register;
        vm.hasRequiredFields = hasRequiredFields;

        if($stateParams.email) {
            vm.form.email = $stateParams.email;
        }

        function register() {
            vm.errors = [];

            if (vm.hasRequiredFields()) {
                API.register(vm.form).then(function(response) {
                    if (response.data == 'EMAIL_TAKEN') {
                        vm.errors.push('Email address already taken. Login to your account.');
                        return;
                    }
                    $state.go('login.user', {
                        message: 'Thanks for signing up. Please login.'
                    });
                }, function(response) {
                    vm.errors.push('There was an issue registering your account. Please try again.');
                });
            }
            
        }

        function hasRequiredFields() {
            if (vm.form) {
                if (vm.form.first_name && vm.form.first_name.trim().length > 0 && vm.form.last_name && vm.form.last_name.trim().length > 0) {
                    if (vm.form.email && vm.form.email.trim().length > 0) {
                        if (vm.form.password && vm.form.password == vm.confirmPassword && vm.form.password.length > 0) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }
    }


})();

(function() {
    'use strict';

    angular
        .module('solution')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($rootScope, $state, $stateParams, API, $log) {

        var vm = this;

        sessionStorage.removeItem('token');
        $rootScope.user = null;

        vm.errors = [];
        vm.messages = [];

        vm.login = login;

        if($stateParams.message) {
            vm.messages.push($stateParams.message);
        }

        function login() {
            vm.errors = [];
            $log.debug('Login', vm.loginForm);
            $log.debug('Login: ' + vm.email + ', ' + vm.password);
            if (vm.loginForm.$valid) {
                vm.attemptLogin = true;
                API.login({ email: vm.email, password: vm.password }).then(function(response) {
                    $log.debug('response', response);
                    sessionStorage.setItem('token', response.data.token);
                    API.getAuthUser().then(function(response) {
                        $rootScope.user = response.data.user;
                        $state.go('app.profile');
                    });
                    vm.attemptLogin = false;
                }, function(response) {
                    vm.attemptLogin = false;
                    vm.errors.push('Incorrect email/password combination.');
                });

            } else {
                vm.errors.push('Email address and password are required.');
            }
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('solution')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'app/auth/login-choice.html',
            })
            .state('login.user', {
                url: '/user',
                templateUrl: 'app/auth/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                params: {
                    message: ''
                }
            })
            .state('login.advertiser', {
                url: '/advertiser',
                templateUrl: 'app/auth/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                params: {
                    message: ''
                }
            })
            .state('register', {
                url: '/register',
                templateUrl: 'app/auth/register.html',
                controller: 'RegisterController',
                controllerAs: 'vm',
                params: {
                    message: ''
                }
            });

        $urlRouterProvider.otherwise('/');
    }

})();

(function() {
  'use strict';

  angular
    .module('solution')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

  }

})();

(function() {
    'use strict';

    angular
        .module('solution')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            
            .state('app', {
                url: '/app',
                template: '<ui-view />',
                abstract: true
            });

        $urlRouterProvider.otherwise('/');
    }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('solution');

})();

(function() {
  'use strict';

  angular
    .module('solution')
    .config(config)
    .config(authConfig);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }


  /** @ngInject */
  function authConfig($httpProvider) {
    $httpProvider.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
  }

})();

angular.module("solution").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/login-choice.html","<div ui-view=\"\"><div class=\"container\"><div class=\"row mt-20 mb-20\"><div class=\"col-md-2\"></div><div class=\"col-md-8 col-xs-12\"><div class=\"text-center\"><h3>Welcome to Solution Table</h3><h5>What type of user are you?</h5></div><div class=\"row text-center login-selector\"><div class=\"col-md-6 active\"><img ng-src=\"assets/images/login-user.png\" width=\"172px\" height=\"172px\"><h1>Personal</h1><p>I\'m looking to use Solution Table to negotiate with people.</p><a ui-sref=\"login.user\" class=\"btn btn-default\">Login as User</a></div><div class=\"col-md-6\"><img ng-src=\"assets/images/login-business.png\" width=\"172px\" height=\"172px\"><h1>Business</h1><p>I\'m looking to use Solution Table to find new business.</p><a ui-sref=\"login.advertiser\" class=\"btn btn-primary\">Login as Advertiser</a></div></div></div><div class=\"col-md-2\"></div></div></div></div>");
$templateCache.put("app/auth/login.html","<div class=\"container\"><div class=\"row mt-20 mb-20\"><div class=\"col-md-3\"></div><div class=\"col-md-6 col-xs-12\"><div class=\"login-container\"><h1 class=\"large text-center\">Welcome, Login</h1><p class=\"lead f-16 text-center\">Solution Table is a <strong>FREE</strong> application for solving real world problems.</p><div class=\"alert alert-danger\" ng-if=\"vm.errors.length > 0\"><p class=\"text-center\" ng-repeat=\"error in vm.errors\" ng-bind=\"error\"></p></div><div class=\"alert alert-success\" ng-if=\"vm.messages.length > 0\"><p class=\"text-center\" ng-repeat=\"message in vm.messages\" ng-bind=\"message\"></p></div><form ng-submit=\"vm.login()\" name=\"vm.loginForm\" novalidate=\"\"><div class=\"form-group pt-15\"><label>Email:</label> <input type=\"email\" class=\"form-control\" ng-model=\"vm.email\" placeholder=\"Email Address\" required=\"\" autofocus=\"\"></div><div class=\"form-group pt-15\"><label>Password:</label> <input type=\"password\" class=\"form-control\" ng-model=\"vm.password\" placeholder=\"Password\" required=\"\"></div><p class=\"text-center\" ng-show=\"vm.attemptLogin\">Attempting to login...</p><button type=\"submit\" class=\"btn btn-default btn-block\" ng-disabled=\"vm.attemptLogin\">Login</button></form><p class=\"mt-15 text-center\">Having problems accessing your account? <a href=\"#\">Click here to reset your password.</a></p></div></div><div class=\"col-md-3\"></div></div></div>");
$templateCache.put("app/auth/register.html","<div class=\"container\"><div class=\"row mt-20\"><div class=\"col-md-7 col-xs-12\"><div class=\"login-container\" style=\"margin-bottom:20px;\"><h1 class=\"large text-center\">Welcome, Register</h1><p class=\"lead f-16 text-center\">Solution Table is a <strong>FREE</strong> application for solving real world problems.</p><div class=\"alert alert-danger\" ng-if=\"vm.errors.length > 0\"><p class=\"text-center\" ng-repeat=\"error in vm.errors\" ng-bind=\"error\"></p></div><form ng-submit=\"vm.register()\" name=\"vm.registerForm\" novalidate=\"\"><div class=\"form-group col-md-6\"><label>First Name:</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.first_name\" placeholder=\"First Name\" required=\"\" autofocus=\"\"></div><div class=\"form-group col-md-6\"><label>Last Name:</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.last_name\" placeholder=\"Last Name\" required=\"\"></div><div class=\"form-group col-md-12\"><label>Email:</label> <input type=\"email\" class=\"form-control\" ng-model=\"vm.form.email\" placeholder=\"Email Address\" required=\"\"></div><div class=\"form-group col-md-6\"><label>Password:</label> <input type=\"password\" class=\"form-control\" ng-model=\"vm.form.password\" placeholder=\"Password\" required=\"\"></div><div class=\"form-group col-md-6\"><label>Confirm Password:</label> <input type=\"password\" class=\"form-control\" ng-model=\"vm.confirmPassword\" placeholder=\"Confirm Password\" required=\"\"></div><div class=\"form-group col-md-6\"><label><input type=\"checkbox\" name=\"terms\" ng-model=\"vm.terms\" ng-checked=\"true\" required=\"\"> Accept our <a ui-sref=\"terms\" target=\"_blank\">terms and conditions</a></label></div><div class=\"form-group col-md-6\"><label><input type=\"checkbox\" name=\"terms\" ng-model=\"vm.form.opt_in\" ng-checked=\"true\"> Allow professionals to contact me</label></div><button type=\"submit\" class=\"btn btn-default btn-block\" ng-disabled=\"!vm.hasRequiredFields()\">Register</button></form></div></div><div class=\"col-md-5\"><h3>Sign-up Questions</h3><hr><p class=\"lead\"><strong><span class=\"fa fa-question-circle\"></span> Does Solution Table cost anything to use?</strong><br>No,<u>Solution Table is completely free</u>. There are no sign-up or monthly fees.</p><p class=\"lead\"><strong><span class=\"fa fa-question-circle\"></span> Who has access to my personal information?</strong><br>Only if you opt-in to marketing promotions, will professionals have access to contact you.</p><p class=\"lead\"><strong><span class=\"fa fa-question-circle\"></span> How does Solution Table work?</strong><br>Our system acts as a medium to apply structure to the negotiation process. <a ui-sref=\"works\">Learn more</a>.</p></div></div></div>");
$templateCache.put("app/negotiation/goal.partial.html","<div class=\"col-sm-12\"><h5 class=\"mt-25\">Goals are what you want to achieve or receive from this negotiation.</h5><hr><form name=\"goalForm\" ng-submit=\"vm.goalService.submit()\"><div class=\"form-group mt-10\" ng-class=\"{ \'has-error\' : !vm.goalService.hasGoalText() && vm.goalService.hasError() }\"><label for=\"goal\" ng-class=\"{ \'text-danger\' : !vm.goalService.hasGoalText() && vm.goalService.hasError() }\">What is an item or outcome you want?</label> <textarea id=\"goal\" class=\"form-control\" rows=\"2\" placeholder=\"Describe what you want.\" ng-model=\"vm.form.negotiation.goals[vm.goalService.getIndex()].goal\" autofocus=\"\"></textarea></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : !vm.goalService.hasReasonText() && vm.goalService.hasError() }\"><label for=\"reason\" ng-class=\"{ \'text-danger\' : !vm.goalService.hasReasonText() && vm.goalService.hasError() }\">Why do you want this or deserve this?</label> <textarea id=\"reason\" class=\"form-control\" rows=\"2\" placeholder=\"Describe why you want the goal.\" ng-model=\"vm.form.negotiation.goals[vm.goalService.getIndex()].reason\"></textarea></div><div class=\"form-group\"><label>Rank the priority of this goal.</label><rzslider rz-slider-model=\"vm.form.negotiation.goals[vm.goalService.getIndex()].priority\" rz-slider-high=\"vm.prioritySlider.maxValue\" rz-slider-options=\"vm.prioritySlider.options\" ng-class=\"Goal.getPriorityLabel(vm.form.negotiation.goals[vm.goalService.getIndex()].priority).toLowerCase().replace(\' \', \'-\')\"></rzslider></div><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-primary pull-right mb-20\" ng-bind=\"vm.goalService.submitBtn()\" ng-disabled=\"!vm.goalService.isValid() && vm.goalService.getIndex() == 0\">Submit Goals</button> <button type=\"button\" class=\"btn btn-success pull-left mb-20\" ng-click=\"vm.goalService.addAdditionalGoal()\" ng-html=\"vm.goalService.getBtnText()\">Add <span ng-bind=\"vm.goalService.getCount()\"></span><span ng-bind=\"vm.goalService.getOrdinal()\"></span> Goal</button></div></form></div>");
$templateCache.put("app/negotiation/resolution.partial.html","<div class=\"col-sm-12\"><h5 class=\"mt-25\">Resolutions are what you want as an outcome of the negotiation.</h5><hr><form ng-submit=\"vm.resService.submit()\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : vm.resService.hasError() }\"><label ng-class=\"{ \'text-danger\' : vm.resService.hasError() }\">What is a desired outcome of this negotiation?</label> <textarea class=\"form-control\" rows=\"2\" placeholder=\"Describe a desired outcome.\" ng-model=\"vm.form.negotiation.resolution\" autofocus=\"\"></textarea></div><div class=\"form-group\"><label for=\"concessions\">My Concessions: What are you willing to give up or change? <small>(leave blank if you have no concessions)</small></label> <textarea id=\"concessions\" class=\"form-control\" rows=\"2\" placeholder=\"Describe what you are willing to give up.\" ng-model=\"vm.form.negotiation.concession\"></textarea></div><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-primary pull-right mb-20\">Submit Resolution</button> <button type=\"button\" class=\"btn btn-link pull-right mb-20\" ng-if=\"vm.resService.isDeclining()\" ng-click=\"vm.resService.cancelDecline()\">Return</button></div></form></div>");
$templateCache.put("app/professional/professional.html","<div class=\"page-professional\"><div class=\"hero-image\" full-height=\"\" height=\"true\"><div class=\"container\"><h1 class=\"text-center\">Find the <strong>right</strong> professional</h1><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-3 col-xs-6 bg-trans\"><input type=\"text\" class=\"form-control input-lg\" ng-model=\"form.zip_code\" placeholder=\"Enter your postal code\"></div><div class=\"col-md-3 col-xs-6 bg-trans\"><semantic-dropdown class=\"form-control input-lg\" placeholder=\"Category\" ng-model=\"vm.form.category\"><option value=\"{{category.id}}\" ng-bind=\"category.name\" ng-repeat=\"category in categories\"></option></semantic-dropdown></div><div class=\"col-md-2 col-xs-12 bg-trans pl-0 pr-0\"><button class=\"btn btn-block btn-primary\" ng-click=\"vm.searchProfessionals()\">Find a Professional</button></div></div><div class=\"row loader-section\"><div class=\"col-md-12\"><div svg-loader=\"puff\" ng-model=\"vm.loaderVisible\" class=\"mt-25\" placeholder=\"Searching for professionals. Please wait...\"></div></div></div></div></div><div class=\"container mt-25\" ng-if=\"vm.professionals\" id=\"professionals\" full-height=\"\"><div class=\"row\"><div class=\"col-md-12\"><h2 class=\"text-primary text-center mb-25\">Professionals Near You</h2><div class=\"well listing\" ng-repeat=\"professional in vm.professionals\"><div class=\"text-right\"><span class=\"uppercase\" ng-bind=\"professional.city + \', \' + professional.state\"></span></div><h3><span ng-bind=\"professional.company.name\"></span><span class=\"color-pop pull-right\" ng-bind=\"professional.company.phone\"></span></h3><h5 ng-bind=\"professional.company.website\"></h5><div class=\"row\"><div class=\"col-lg-9 col-sm-12\"><p class=\"description\" trim-to=\"{{professional.description}}\" show-more=\"true\" length=\"500\"></p></div><div class=\"col-lg-3 col-sm-12 text-center\"><div class=\"row\"><div class=\"col-lg-12 col-md-6\"><a href=\"{{professional.company.website}}\" ng-click=\"$event.preventDefault();vm.openWebsite(professional.company.website)\" class=\"btn btn-primary btn-block\">Visit Website</a></div><div class=\"col-lg-12 col-md-6\"><a href=\"#\" class=\"btn btn-block btn-link\">View Profile</a></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/footer/footer.html","<div class=\"footer\"><p class=\"text-center\">&copy; 2016 Solution Table LLC v1.1.0a</p></div>");
$templateCache.put("app/components/goal/goalContainer.html","<div class=\"list-group-container\"><div class=\"list-group\" ng-class=\"{\'scroll-active\' : showScrollMsg}\"><a href=\"#\" class=\"list-group-item pt-15\" ng-show=\"!goals || goals.length == 0 || !Goal.isValid(goals[0])\"><h4 class=\"list-group-item-heading\">You currently do not have any goals for this negotiation. Please create one now.</h4></a> <a class=\"list-group-item\" ng-repeat=\"goal in goals\" ng-show=\"Goal.isValid(goal)\" ng-click=\"edit({goal: goal})\"><div class=\"text-right mb-5\"><span class=\"label\" ng-class=\"Goal.getPriorityClass(goal.priority)\" ng-bind=\"Goal.getPriorityLabel(goal.priority)\"></span></div><h4 class=\"list-group-item-heading\">{{goal.goal}}</h4><p class=\"list-group-item-text\">{{goal.reason}}</p></a></div><div class=\"list-group-message\" ng-show=\"showScrollMsg\"><span ng-show=\"showScrollDown\">Scroll down to read more <i class=\"fa fa-angle-down\"></i></span> <span ng-show=\"showScrollUp\"><a ng-click=\"scrollTop()\">Scroll to top <i class=\"fa fa-angle-up\"></i></a></span></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-inverse\" ng-cloak=\"\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"logo\" ui-sref=\"home\"><img ng-src=\"/assets/images/logo-white.png\" width=\"125px\"></a></div><div class=\"collapse navbar-collapse\"><ul class=\"nav navbar-nav\"><li ui-sref-active=\"active\"><a ui-sref=\"about\">About Us</a></li><li ui-sref-active=\"active\"><a ui-sref=\"works\">How it Works</a></li><li ui-sref-active=\"active\"><a ui-sref=\"professional\">Find a Professional</a></li><li ui-sref-active=\"active\"><a ui-sref=\"contact\">Contact Us</a></li></ul><ul class=\"nav navbar-nav navbar-right\" ng-if=\"user\"><li class=\"dropdown\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" add=\"open\" role=\"button\"><span ng-bind=\"user.first_name + \' \' + user.last_name\"></span> <span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li><a ui-sref=\"app.profile\">Profile</a></li><li><a ng-click=\"main.logout()\">Logout</a></li></ul></li></ul><div class=\"navbar-btns\" ng-hide=\"user\"><a class=\"btn btn-success pull-right\" ui-sref=\"login\">Login</a> <a class=\"btn btn-link pull-right\" ui-sref=\"register\">Register</a></div></div></div></nav>");
$templateCache.put("app/components/svgLoader/svgLoader.html","<div class=\"svg-loader-container\" ng-class=\"defaultClasses\" ng-show=\"isVisible\"><div ng-include=\"\'/bower_components/SVG-loaders/svg-loaders/\'+icon+\'.svg\'\"></div><p class=\"lead text-white\" ng-if=\"placeholder\" ng-bind=\"placeholder\"></p></div>");
$templateCache.put("app/modules/dashboard/dashboard.html","<div class=\"container profile-page\"><div class=\"jumbotron\" ng-if=\"vm.negotiations.length == 0\"><h1>Welcome to Solution Table!</h1><p>Organize your problems and goals into a negotiation now. Click the <em>\"Get Started\"</em> button to begin a negotiation.</p><p><a class=\"btn btn-primary btn-lg\" ui-sref=\"app.negotiation.create\">Get Started</a></p></div><div ng-if=\"vm.negotiations.length > 0\"><h3 class=\"pull-left\">Welcome, <span ng-bind=\"vm.user.first_name+\' \'+vm.user.last_name\"></span></h3><button type=\"button\" class=\"btn btn-primary mt-25 pull-right\" ui-sref=\"app.negotiation.create\">Start Negotiation <i class=\"fa fa-arrow-right\"></i></button><div class=\"clearfix\"></div><hr><div class=\"well\"><uib-tabset><uib-tab heading=\"Active Negotiations\"><h4>Active Negotiations</h4><p>These are your ongoing and open (active) negotiations between you and another party. Items marked with \"Waiting on your Feedback\" are waiting for your input regarding entering your goals, reviewing a resolution or proposing a new one.</p><hr><h6 ng-if=\"(vm.negotiations | filter: {status:\'Active\'}).length == 0\">You currently do not have any active negotiations.</h6><div class=\"panel\" ng-repeat=\"negotiation in vm.negotiations | filter:{status:\'Active\'} | orderBy:\'updated_at_time\':true\" ng-class=\"{\'panel-primary\' : vm.negService.isYourTurn(negotiation), \'panel-negotiation\' : !vm.negService.isYourTurn(negotiation) }\"><div class=\"panel-heading\"><h3 class=\"panel-title\" ng-show=\"vm.negService.isYourTurn(negotiation)\">Waiting On Your Feedback</h3><h3 class=\"panel-title\" ng-hide=\"vm.negService.isYourTurn(negotiation)\">Waiting On {{negotiation.participant.name}}</h3><span class=\"label status-label\" ng-class=\"vm.negService.getStatusLabel(negotiation)\" ng-bind=\"negotiation.status\"></span></div><div class=\"panel-body\"><strong><small>Participant</small></strong><p class=\"list-group-item-text\">{{negotiation.participant.name}} <small>({{negotiation.participant.email}})</small></p><strong><small>Summary</small></strong><p class=\"list-group-item-text\">{{negotiation.description}}</p></div><div class=\"panel-footer text-right\"><a ui-sref=\"app.negotiation.view({identity:negotiation.id})\" class=\"btn btn-primary\" ng-bind=\"vm.negService.getActionText(negotiation)\"></a></div></div></uib-tab><uib-tab heading=\"Resolved Negotiations\"><h4>Resolved Negotiations</h4><p>These are negotiations that have reached a resolution. This means that at least one resolution was accepted, that was proposed by either party.</p><hr><h6 ng-if=\"(vm.negotiations | filter: {status:\'Resolved\'}).length == 0\">You currently do not have any resolved negotiations. Please either create a new negotiation or work at resolving an open one.</h6><div class=\"panel panel-success\" ng-repeat=\"negotiation in vm.negotiations | filter:{ status: \'Resolved\' }\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Resolved at {{ negotiation.updated_at_time | date:\'MM/dd/yyyy hh:mm a\'}}</h3></div><div class=\"panel-body\"><strong><small>Participant</small></strong><p class=\"list-group-item-text\">{{negotiation.participant.name}} <small>({{negotiation.participant.email}})</small></p><strong><small>Summary</small></strong><p class=\"list-group-item-text\">{{negotiation.description}}</p></div><div class=\"panel-footer text-right\"><a ui-sref=\"app.negotiation.view({identity:negotiation.id})\" class=\"btn btn-primary\">View</a></div></div></uib-tab><uib-tab heading=\"Impasse Negotiations\"><h4>Impasse Negotiations</h4><p>These are negotiations that did not reach a resolution. This means that neither party could come to an agreement.</p><hr><h6 ng-if=\"(vm.negotiations | filter: {status:\'Impasse\'}).length == 0\">You currently do not have any impasse negotiations.</h6><div class=\"panel panel-danger\" ng-repeat=\"negotiation in vm.negotiations | filter:{ status: \'Impasse\' }\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Impasse at {{ negotiation.updated_at_time | date:\'MM/dd/yyyy hh:mm a\'}}</h3></div><div class=\"panel-body\"><strong><small>Participant</small></strong><p class=\"list-group-item-text\">{{negotiation.participant.name}} <small>({{negotiation.participant.email}})</small></p><strong><small>Summary</small></strong><p class=\"list-group-item-text\">{{negotiation.description}}</p></div><div class=\"panel-footer text-right\"><a ui-sref=\"app.negotiation.view({identity:negotiation.id})\" class=\"btn btn-primary\">View</a></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/modules/negotiation/negotiation-create.html","<div class=\"container negotiation-create-page\"><div class=\"jumbotron\"><div ng-show=\"vm.currentStep == 1\" class=\"row\"><h3>Who are you negotiating with?</h3><p>Please enter their first name, last name and email address.</p><hr><div class=\"form-group\"><label for=\"firstName\">Their first name:</label> <input id=\"firstName\" type=\"text\" class=\"form-control\" ng-model=\"vm.negotiation.participant.firstName\" placeholder=\"First Name\" autofocus=\"\"></div><div class=\"form-group\"><label for=\"lastName\">Their last name:</label> <input id=\"lastName\" type=\"text\" class=\"form-control\" ng-model=\"vm.negotiation.participant.lastName\" placeholder=\"Last Name\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : !vm.isValidEmail() }\"><label for=\"email\">Their email address:</label> <input id=\"email\" type=\"email\" class=\"form-control\" ng-model=\"vm.negotiation.participant.email\" placeholder=\"Email Address\"><div class=\"help-block\" ng-show=\"!vm.isValidEmail()\"><p class=\"text-danger\">Please enter the <strong>other person\'s</strong> email address.</p></div></div></div><div ng-show=\"vm.currentStep == 2\" class=\"row\"><h3>What is this negotiation about?</h3><p>Please describe the negotiation. Explain for <strong><span ng-bind=\"vm.negotiation.participant.firstName\"></span></strong> to understand.</p><hr><div class=\"form-group\"><textarea class=\"form-control\" rows=\"4\" ng-model=\"vm.negotiation.description\" placeholder=\"Describe the negotiation.\" autofocus=\"\"></textarea><div class=\"help-block\" ng-show=\"vm.negotiation.description.length < 100\"><p>Hint: Longer descriptions help the other person understand what the problem is.</p></div></div></div><div class=\"row\" ng-show=\"vm.currentStep == 3\"><div class=\"col-md-8 col-sm-12\"><h3>Create goals for the negotiation.</h3><p>Goals are what you want to achieve or receive from this negotiation.</p><hr><form name=\"goalForm\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : Goal.hasError() && goalForm.goal.$invalid }\"><label for=\"goal\" ng-class=\"{ \'text-danger\' : Goal.hasError() && goalForm.goal.$invalid }\">What is an item or outcome you want?</label> <textarea id=\"goal\" name=\"goal\" class=\"form-control\" rows=\"2\" placeholder=\"Describe what you want.\" ng-model=\"Goal.values[Goal.getIndex()].goal\" autofocus=\"\" required=\"\"></textarea></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : Goal.hasError() && goalForm.reason.$invalid }\"><label for=\"reason\" ng-class=\"{ \'text-danger\' : Goal.hasError() && goalForm.reason.$invalid }\">Why do you want this or deserve this?</label> <textarea id=\"reason\" name=\"reason\" class=\"form-control\" rows=\"2\" placeholder=\"Describe why you want the goal.\" ng-model=\"Goal.values[Goal.getIndex()].reason\" required=\"\"></textarea></div><div class=\"form-group\"><label>Rank the priority of this goal.</label><rzslider rz-slider-model=\"Goal.values[Goal.getIndex()].priority\" rz-slider-high=\"vm.prioritySlider.maxValue\" rz-slider-options=\"vm.prioritySlider.options\" ng-class=\"Goal.getPriorityLabel(Goal.values[Goal.getIndex()].priority).toLowerCase().replace(\' \', \'-\')\"></rzslider></div></form></div><div class=\"col-md-4 col-xs-12\"><h5 class=\"pull-left\">Current Goals <span class=\"badge\" ng-class=\"{\'badge-success\' : Goal.getCount() > 0 }\" ng-bind=\"Goal.getCount()\"></span></h5><div class=\"clearfix\"></div><div goal-container=\"Goal.values\" edit=\"Goal.edit(goal)\"></div></div></div><div ng-show=\"vm.currentStep >= 4\" class=\"row\"><h3>Review your information.</h3><p>Please review the other party\'s information, the negotiation summary and the goals you have created. By clicking <em>\"Submit\"</em>, <span ng-bind=\"vm.negotiation.participant.firstName\"></span> will receive the information you have provided.</p><hr><h4>Who are you negotiating with?</h4><p class=\"mb-0 f-14\">Name: <span ng-bind=\"vm.negotiation.participant.firstName + \' \' + vm.negotiation.participant.lastName\"></span></p><p class=\"f-14\">Email: <span ng-bind=\"vm.negotiation.participant.email\"></span></p><h4>What is this negotiation about?</h4><p class=\"f-14\" ng-bind=\"vm.negotiation.description\"></p><h4>Goals for the negotiation <span class=\"badge badge-success\" ng-bind=\"Goal.getCount()\"></span>:</h4><div class=\"goal\" ng-repeat=\"goal in Goal.getAll()\" ng-show=\"Goal.isValid(goal)\"><span class=\"label pull-right\" ng-class=\"Goal.getPriorityClass(goal.priority)\" ng-bind=\"Goal.getPriorityLabel(goal.priority)\"></span> <strong><small>Goal:</small></strong><p ng-bind=\"goal.goal\"></p><strong><small>Reason:</small></strong><p ng-bind=\"goal.reason\"></p></div></div><div class=\"row mt-20\"><button type=\"button\" class=\"btn-lg btn-default\" ng-if=\"vm.currentStep > 1\" ng-click=\"vm.previousStep()\">Previous</button> <button type=\"button\" class=\"btn-lg btn-primary pull-right\" ng-class=\"{ \'disabled\' : !vm.canAdvance()}\" ng-click=\"vm.nextStep()\">{{ vm.currentStep == 4 ? \'Submit\' : \'Next\' }}</button> <button type=\"button\" class=\"btn-lg btn-success pull-right mr-20\" ng-show=\"vm.currentStep == 3\" ng-click=\"Goal.add()\">Add {{Goal.getIndex()+2}}<sup ng-bind=\"Goal.getSuffix()\"></sup> Goal</button></div></div></div>");
$templateCache.put("app/modules/negotiation/negotiation-view.html","<div class=\"container\"><div class=\"jumbotron\" ng-if=\"vm.negotiations.length == 0\"><h1>Welcome to Solution Table!</h1><p>You can organize your problems and goals into a simple negotiation now. Click the <em>\"Get Started\"</em> button to begin a new negotiation.</p><p><a class=\"btn btn-primary btn-lg\" ui-sref=\"app.negotiation.create\">Get Started</a></p></div><h3 class=\"pull-left hide-print\">Welcome, <span ng-bind=\"user.first_name+\' \'+user.last_name\"></span></h3><button type=\"button\" class=\"btn btn-danger mt-25 pull-right\" ng-click=\"vm.confirmImpasse()\" ng-show=\"vm.negotiation.status != \'Resolved\' && vm.negotiation.status != \'Impasse\'\">Impasse Negotiation</button> <button class=\"btn btn-link mt-25 pull-right\" href=\"#\" ui-sref=\"app.profile\">Return</button><div class=\"clearfix\"></div><hr><div class=\"row well\"><div><div class=\"text-right\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.print()\">Print Negotiation</button></div><div class=\"row\"><h5 class=\"text-center\">What is this negotiation about?</h5><blockquote style=\"border:0\">{{vm.negotiation.description}}</blockquote></div><div class=\"row\"><div class=\"col-md-6 col-xs-12 participant-name\"><h4 class=\"text-center\" ng-bind=\"vm.negotiation.participant.name\"></h4></div><div class=\"col-md-6 col-xs-12 your-name\"><h4 class=\"text-center\">You</h4></div></div><div class=\"timeline\"><div ng-if=\"vm.getStep() == 6\"><div class=\"timeline-block-title\"><div class=\"timeline-icon bg-dark-blue\"><span>Solution</span></div></div><div class=\"timeline-block blue\"><div class=\"timeline-item left\" ng-if=\"(vm.negotiation.participant.resolutions | filter:{\'accepted\' : \'1\'}).length > 0\"><div class=\"list-group resolutions-group participant\" ng-style=\"{\'max-height\' : vm.styles.participant.resolutions}\"><a class=\"list-group-item\" ng-repeat=\"resolution in vm.negotiation.participant.resolutions | filter:{\'accepted\' : \'1\'}\"><div class=\"text-right mb-5\"><span class=\"label\" ng-class=\"vm.resService.getLabelColor(resolution)\" ng-bind=\"vm.resService.getLabelText(resolution)\"></span></div><strong>Resolution</strong><p class=\"list-group-item-heading\" ng-bind=\"resolution.resolution\"></p><strong>Concession</strong><p class=\"list-group-item-text\">{{resolution.concession.length > 0 ? resolution.concession : \'No concession.\'}}</p></a><div class=\"show-more\" ng-if=\"vm.resService.checkOverflow(\'participant\')\"><button class=\"btn btn-primary\" ng-click=\"vm.resService.expandResolutions(\'participant\')\">Show More</button></div></div></div><div class=\"timeline-item right\" ng-if=\"(negotiation.instigator.resolutions | filter:{\'accepted\' : \'1\'}).length > 0\"><div class=\"list-group resolutions-group instigator\" ng-style=\"{\'max-height\' : styles.instigator.resolutions}\"><a class=\"list-group-item\" ng-repeat=\"resolution in negotiation.instigator.resolutions | filter:{\'accepted\' : \'1\'}\"><div class=\"text-right mb-5\"><span class=\"label\" ng-class=\"vm.resService.getLabelColor(resolution)\" ng-bind=\"vm.resService.getLabelText(resolution)\"></span></div><strong>Resolution</strong><p class=\"list-group-item-heading\" ng-bind=\"resolution.resolution\"></p><strong>Concession</strong><p class=\"list-group-item-text\">{{resolution.concession.length > 0 ? resolution.concession : \'No concession.\'}}</p></a><div class=\"show-more\" ng-if=\"vm.resService.checkOverflow(\'instigator\')\"><button class=\"btn btn-primary\" ng-click=\"vm.resService.expandResolutions(\'instigator\')\">Show More</button></div></div></div></div><hr></div><div ng-if=\"vm.getStep() == 7\"><div class=\"timeline-block-title\"><div class=\"timeline-icon bg-dark-red\"><span>Impasse</span></div></div><div class=\"timeline-block red\"><div class=\"timeline-item right\"><div class=\"placeholder text-center\"><p>You have selected to impasse this negotitation. We recommend contacting a professional to continue the negotiation process.</p></div></div></div><hr></div><div ng-if=\"vm.getStep() > 2\"><div class=\"timeline-block-title\"><div class=\"timeline-icon bg-light-green\"><span>Resolutions</span></div></div><div class=\"timeline-block green\"><div class=\"timeline-item left\" ng-if=\"vm.getStep() == 4 || vm.getStep() == 3\" ng-class=\"{\'active\' : vm.getStep() == 4}\"><div class=\"placeholder text-center\"><p ng-if=\"vm.getStep() == 4\" class=\"lead\">You are currently waiting for <span ng-bind=\"vm.negotiation.participant.name\"></span> to review your submitted resolution. Please check back later or wait to receive an email when <span ng-bind=\"vm.negotiation.participant.first_name\"></span> responds.</p><p ng-if=\"vm.getStep() == 3\" class=\"lead\"><span ng-bind=\"vm.negotiation.participant.name\"></span> has not proposed any resolutions. You may submit a resolution at this time.</p></div></div><div class=\"timeline-item left\" ng-if=\"vm.negotiation.participant.resolutions.length > 0\"><div class=\"list-group resolutions-group participant\" ng-style=\"{\'max-height\' : vm.styles.participant.resolutions}\"><a class=\"list-group-item\" ng-repeat=\"resolution in vm.negotiation.participant.resolutions\"><div class=\"text-right mb-5\"><span class=\"label\" ng-class=\"vm.resService.getLabelColor(resolution)\" ng-bind=\"vm.resService.getLabelText(resolution)\"></span></div><strong>Resolution</strong><p class=\"list-group-item-heading\" ng-bind=\"resolution.resolution\"></p><strong>Concession</strong><p class=\"list-group-item-text\">{{resolution.concession.length > 0 ? resolution.concession : \'No concession.\'}}</p></a><div class=\"show-more\" ng-if=\"vm.resService.checkOverflow(\'participant\')\"><button class=\"btn btn-primary\" ng-click=\"vm.resService.expandResolutions(\'participant\')\">Show More</button></div></div></div><div class=\"timeline-item right\" ng-if=\"vm.getStep() == 5\" ng-class=\"{\'active\' : vm.getStep() == 5}\"><div ng-hide=\"vm.resService.isDeclining()\" class=\"resolutionForm\"><h5 class=\"resolution-title\">Please review <span>{{pluralize(negotiation.participant.name)}}</span> resolution...</h5><form class=\"vm.resolutionForm\"><h6>Resolution</h6><p ng-bind=\"vm.resService.current().resolution\"></p><div ng-if=\"vm.resService.current().concession.trim().length > 0\"><h6>Concessions</h6><p ng-bind=\"vm.resService.current().concession\"></p></div><div><button type=\"button\" ng-click=\"vm.resService.accept()\" class=\"btn btn-success pull-right mb-20\">Accept</button> <button type=\"button\" ng-click=\"vm.resService.decline()\" class=\"btn btn-warning pull-left mb-20\">Propose Alternative</button></div></form></div><div ng-include=\"\'app/negotiation/resolution.partial.html\'\" ng-show=\"vm.resService.isDeclining()\"></div></div><div class=\"clearfix\" ng-if=\"vm.getStep() == 5\"></div><div class=\"timeline-item right\" ng-class=\"{\'active\' : vm.getStep() == 3}\"><div ng-include=\"\'app/negotiation/resolution.partial.html\'\" ng-if=\"vm.getStep() == 3\"></div><div class=\"list-group resolutions-group instigator\" ng-style=\"{\'max-height\' : styles.instigator.resolutions}\"><a class=\"list-group-item\" ng-repeat=\"resolution in vm.negotiation.instigator.resolutions\"><div class=\"text-right mb-5\"><span class=\"label\" ng-class=\"vm.resService.getLabelColor(resolution)\" ng-bind=\"vm.resService.getLabelText(resolution)\"></span></div><strong>Resolution</strong><p class=\"list-group-item-heading\" ng-bind=\"resolution.resolution\"></p><strong>Concession</strong><p class=\"list-group-item-text\">{{resolution.concession.length > 0 ? resolution.concession : \'No concession.\'}}</p></a><div class=\"show-more\" ng-if=\"vm.resService.checkOverflow(\'instigator\')\"><button class=\"btn btn-primary\" ng-click=\"vm.resService.expandResolutions(\'instigator\')\">Show More</button></div></div></div></div><hr></div><div class=\"timeline-block-title\"><div class=\"timeline-icon bg-orange\"><span>Goals</span></div></div><div class=\"timeline-block orange\"><div class=\"timeline-item left\"><div class=\"placeholder\" ng-show=\"vm.negotiation.participant.goals.length == 0\"><p class=\"lead\">You are currently waiting for <span ng-bind=\"vm.negotiation.participant.name\"></span> to submit goals for the negotiation. Please check back later or wait to receive an email when <span ng-bind=\"vm.negotiation.participant.first_name\"></span> submits goals.</p></div><div class=\"list-group goals-group participant\" ng-style=\"{\'max-height\' : vm.styles.participant.goals}\"><a class=\"list-group-item\" ng-repeat=\"goal in vm.negotiation.participant.goals\"><div class=\"text-right mb-5\"><span class=\"label\" ng-class=\"Goal.getPriorityClass(goal.priority)\" ng-bind=\"Goal.getPriorityLabel(goal.priority)\"></span></div><strong>Goal</strong><p class=\"list-group-item-heading\">{{goal.goal}}</p><strong>Reason</strong><p class=\"list-group-item-text\">{{goal.reason}}</p></a><div class=\"show-more\" ng-if=\"vm.goalService.checkGoalOverflow(\'participant\')\"><button class=\"btn btn-primary\" ng-click=\"vm.goalService.expandGoals(\'participant\')\">Show More</button></div></div></div><div class=\"timeline-item right\" ng-class=\"{\'active\' : vm.negotiation.instigator.goals.length == 0}\"><div ng-include=\"\'app/negotiation/goal.partial.html\'\" ng-show=\"vm.negotiation.instigator.goals.length == 0\"></div><div class=\"list-group goals-group instigator\" ng-style=\"{\'max-height\' : vm.styles.instigator.goals}\"><a class=\"list-group-item\" ng-repeat=\"goal in vm.negotiation.instigator.goals\"><div class=\"text-right mb-5\"><span class=\"label\" ng-class=\"Goal.getPriorityClass(goal.priority)\" ng-bind=\"Goal.getPriorityLabel(goal.priority)\"></span></div><strong>Goal</strong><p class=\"list-group-item-heading\">{{goal.goal}}</p><strong>Reason</strong><p class=\"list-group-item-text\">{{goal.reason}}</p></a><div class=\"show-more\" ng-if=\"vm.goalService.checkGoalOverflow(\'instigator\')\"><button class=\"btn btn-primary\" ng-click=\"vm.goalService.expandGoals(\'instigator\')\">Show More</button></div></div></div></div><div class=\"timeline-block-title\"><div class=\"timeline-icon bg-slate\"><span>Start</span></div></div></div></div></div></div>");
$templateCache.put("app/modules/marketing/401.html","401");
$templateCache.put("app/modules/marketing/404.html","404");
$templateCache.put("app/modules/marketing/about-us.html","<div class=\"container mt-20\"><h1>About Us</h1><hr><img ng-src=\"/assets/images/adam.png\" width=\"220px\" class=\"pull-left p-20\"><p class=\"lead\">Solution Table, LLC was founded by Attorney Adam J. Keilen at Keilen Law, PLC (Kalamazoo, Michigan). In his practice, Mr. Keilen is a problem solver; oftentimes, Mr. Keilen noticed that opposing parties were wasting time and money arguing, yet both sides failed to understand their opponent’s goals and underlying interests. Thus, Mr. Keilen developed a software platform for organizing disputes, thereby helping clients organize, prioritize, and resolve their problems, so they can get back to what matters most.</p><p class=\"lead\">The result: <strong>www.solutiontable.com</strong>.</p><p class=\"lead\">To contact Attorney Keilen, or Keilen Law, PLC, or for more information about Alternative Dispute Resolution through Keilen Law or other legal services, please visit us today at: <a href=\"http://www.keilenlaw.com/practice-areas/litigation/alternative-dispute-resolution/\">http://www.keilenlaw.com/practice-areas/litigation/alternative-dispute-resolution/</a>.</p></div>");
$templateCache.put("app/modules/marketing/contact-us.html","<div class=\"bg-dark-grey pt-80 pb-80\"><div class=\"container text-center\"><h2 class=\"text-white\">Contact Us</h2><p class=\"lead text-white\">Have a question or need help? We can be reached in a variety of different ways, please pick the most convenient way for you.</p></div></div><div class=\"container pt-40 pb-80\"><div class=\"row\"><div class=\"col-md-3 col-xs-12\"><h4>Our Office</h4><p><span class=\"fa fa-building\"></span> 141 E. Michigan Avenue, Suite 600<br>Kalamazoo, MI 49007</p><p><span class=\"fa fa-phone\"></span> (269) 830-7838</p><p><span class=\"fa fa-envelope\"></span> support@solutiontable.com</p></div><div class=\"col-md-9 col-xs-12\"><h4>Contact Us Form</h4><form name=\"vm.contactForm\" ng-show=\"!vm.sentSuccess\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.contactForm.name.$invalid}\"><label class=\"control-label\">Your Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"vm.form.name\" placeholder=\"Your Name\" autofocus=\"\" required=\"\"><div class=\"help-block\" ng-if=\"vm.submitted && vm.contactForm.name.$invalid\"><p class=\"text-danger\">Your name is a required field.</p></div></div><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.contactForm.email.$invalid}\"><label class=\"control-label\">Email Address</label> <input type=\"text\" class=\"form-control\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email Address\" required=\"\"><div class=\"help-block\" ng-if=\"vm.submitted && vm.contactForm.email.$invalid\"><p class=\"text-danger\">Your email is a required field.</p></div></div><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.contactForm.message.$invalid}\"><label class=\"control-label\">Your Message</label> <textarea class=\"form-control\" name=\"message\" ng-model=\"vm.form.message\" rows=\"4\" placeholder=\"Your Message\" required=\"\"></textarea><div class=\"help-block\" ng-if=\"vm.submitted && vm.contactForm.message.$invalid\"><p class=\"text-danger\">Your message is a required field.</p></div></div><div class=\"text-right\"><button class=\"btn btn-primary\" ng-click=\"vm.sendMessage()\" ng-disabled=\"vm.submitted && vm.contactForm.$invalid\">Send Message</button></div></form></div></div></div>");
$templateCache.put("app/modules/marketing/how-it-works.html","<div class=\"container mt-20\"><h1>How It Works</h1><p class=\"lead\">What you need to know about <strong>Solution Table</strong>. Click the steps below to learn more about each step of the negotiation process.</p><hr><div class=\"row text-center\"><div class=\"step-icon slate\" ng-class=\"{\'active\' : step == 1}\" ng-click=\"step = 1\" ng-mouseover=\"step = 1\">1</div><div class=\"step-icon orange\" ng-class=\"{\'active\' : step == 2}\" ng-click=\"step = 2\" ng-mouseover=\"step = 2\">2</div><div class=\"step-icon green\" ng-class=\"{\'active\' : step == 3}\" ng-click=\"step = 3\" ng-mouseover=\"step = 3\">3</div><div class=\"step-icon blue\" ng-class=\"{\'active\' : step == 4}\" ng-click=\"step = 4\" ng-mouseover=\"step = 4\">4</div><div class=\"step-icon red\" ng-class=\"{\'active\' : step == 5}\" ng-click=\"step = 5\" ng-mouseover=\"step = 5\">X</div></div><hr><div class=\"step\" ng-show=\"!step || step == 1\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><h5 class=\"step-section slate\">Getting Started</h5><h4 class=\"step-section slate\">Creating a Negotiation</h4><strong>Invite</strong><p>Enter the other party\'s name and email that you want to invite to a negotiation.</p><strong>Describe</strong><p>Summarize what the negotiation is about so that the other party can clearly understand what the problem is.</p><strong>Submit</strong><p>Once you have entered your goals and reviewed the summary of the negotiation, submit and wait for the other party to respond.</p></div><div class=\"col-md-6 col-xs-12\"><img ng-src=\"/assets/images/step-1.png\" width=\"500px\"></div></div></div><div class=\"step\" ng-show=\"step == 2\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><h5 class=\"step-section orange\">Getting Started</h5><h4 class=\"step-section orange\">Submitting Your Goals</h4><strong>Explain</strong><p>Tell the other party WHAT you want – your goal. Tell the other party WHY you want it – explain why this is important, the underlying interest.</p><strong>Prioritize</strong><p>Rank your goals based on the level of priority to you. Help the other party understand how important the Goal is.</p><strong>Submit</strong><p>Once you have organized your goals, make sure to click \"Submit goals\" to save your goals. You can create multiple goals for a single negotiation.</p></div><div class=\"col-md-6 col-xs-12\"><img ng-src=\"/assets/images/step-2.png\" width=\"500px\"></div></div></div><div class=\"step\" ng-show=\"step == 3\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><h5 class=\"step-section green\">Getting Started</h5><h4 class=\"step-section green\">Proposing a Resolution</h4><strong>Resolution</strong><p>Explain how you would like to resolve the negotiation, understanding both sides\' disclosure items.</p><strong>Concessions</strong><p>Tell the other side what you are willing to give up, in order to receive your desired outcome.</p><strong>Accept or Counter</strong><p>Once you have received a resolution, you have the option to accept it or counter it with an alternative resolution.</p></div><div class=\"col-md-6 col-xs-12\"><img ng-src=\"/assets/images/step-3.png\" width=\"500px\"></div></div></div><div class=\"step\" ng-show=\"step == 4\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><h5 class=\"step-section blue\">Getting Started</h5><h4 class=\"step-section blue\">Accepting a Resolution</h4><strong>Resolved Negotiation</strong><p>Once you accept a resolution, the resolution will move to the \"Solution\" section of the timeline and the negotiation will be marked as resolved.</p></div><div class=\"col-md-6 col-xs-12\"><img ng-src=\"/assets/images/step-4.png\" width=\"500px\"></div></div></div><div class=\"step\" ng-show=\"step == 5\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><h5 class=\"step-section red\">Getting Started</h5><h4 class=\"step-section red\">Impasse a Negotiation</h4><strong>What does impasse mean?</strong><p>Sometimes a resolution can not be reched on a given problem, that is why you have the option to impasse or \"close\" the negotiation from further discussion.</p><strong>How do I impasse a negotiation?</strong><p>At the top of every negotiation timeline is a button that says \"Impasse Negotiation\". We will ask you to confirm your selection and then the negotiation will be locked.</p><strong>What does the other party see?</strong><p>When you impasse a negotiation, the other party will see that you impassed on a specific date, as well as receive an email alert that the action occured.</p></div><div class=\"col-md-6 col-xs-12\"><img ng-src=\"/assets/images/step-5.png\" width=\"500px\"></div></div></div></div>");
$templateCache.put("app/modules/marketing/index.html","<div class=\"page-home bg-dark-grey\"><div class=\"container\"><div class=\"row pt-80\"><div class=\"col-sm-10 col-sm-offset-1 text-center\"><h1 class=\"large text-white\">Two Parties, One Problem</h1><p class=\"lead text-white pt-15\">Use the Solution Table Exercise to Organize the Problem and Solve It.</p></div></div><div class=\"row pt-30\"><div class=\"col-sm-6 col-sm-offset-3\"><form class=\"row main-form\"><div class=\"col-md-6\"><input type=\"email\" name=\"email\" ng-model=\"email\" class=\"form-control\" placeholder=\"Email Address\"></div><div class=\"col-md-6\"><button type=\"submit\" class=\"btn btn-default btn-block\" ui-sref=\"register({email:\'\'})\">Register</button></div></form></div></div><div class=\"row pt-50\"><img ng-src=\"/assets/images/app.png\"></div></div></div>");}]);